import { render, staticRenderFns } from "./_Register.vue?vue&type=template&id=5818c40c&scoped=true"
import script from "./_Register.vue?vue&type=script&lang=js"
export * from "./_Register.vue?vue&type=script&lang=js"
import style0 from "./_Register.vue?vue&type=style&index=0&id=5818c40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818c40c",
  null
  
)

export default component.exports